import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import { HashLink } from 'react-router-hash-link';

import { sendResetPasswordEmail } from 'libraries/utils'

import { login, register } from 'actions/asyncMember'

import VerifyDialog from 'components/dialog/VerifyDialog'
import ForgetPasswordDialog from 'components/dialog/ForgetPasswordDialog'

import logo from 'static/images/icons/cellwine-logo.svg'

class Header extends Component {
    constructor() {
        super()
        this.state = {
            action: '',
            type: '',
            isOpenVerifyDialog: false,
            isOpenForgotPasswordDialog: false,
        }
    }

    handleOnOpenVerifyDialog = (action) => {
        this.setState({
            isOpenVerifyDialog: !this.state.isOpenVerifyDialog,
            action: action || this.state.action
        })
    }

    handleOnSubmit = (type, data) => {
        const { action } = this.state
        if (action === 'login') {
            this.props.login(type, data)
        } else {
            this.props.register(type, data)
        }
    }

    handleActionChange = (action) => {
        this.setState({
            isOpenVerifyDialog: false,
            isOpenForgotPasswordDialog: false,
        })
        if (action === 'forgetpassword') {
            setTimeout(() => {
                this.setState({
                    isOpenForgotPasswordDialog: true,
                })
            }, 200)
        } else {
            setTimeout(() => this.handleOnOpenVerifyDialog(action), 200)
        }

    }

    handleCloseForgotPasswordDialog = () => {
        this.setState({
            isOpenForgotPasswordDialog: false,
        })
    }

    handleForgetPasswordSubmit = (email) => {
        sendResetPasswordEmail(email)
    }

    render() {
        const { isOpenVerifyDialog, isOpenForgotPasswordDialog } = this.state
        return (
            <header>
                <nav className="navbar navbar-expand-md fixed-top navbar-dark">
                    <Link to="/" className="navbar-brand">
                        <img className="CELLWINE-lg-logo CELLWINE-sm-logo" src={logo} alt="logo" />
                    </Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#myNavbar"
                        aria-controls="myNavbar" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse flex-grow-1 text-right" id="myNavbar">
                        <ul className="navbar-nav ml-auto flex-nowrap">
                            <li className="nav-item">
                                <HashLink to="/#section2" className="nav-link m-2 menu-item">
                                    租用計算
                                </HashLink>
                            </li>
                            <li className="nav-item">
                                <HashLink to="/#section3" className="nav-link m-2 menu-item">
                                    紅酒管家
                                </HashLink>
                            </li>
                            <li className="nav-item">
                                <Link to="/app_index" className="nav-link m-2 menu-item">
                                    CELLWINE App
                                </Link>
                            </li>
                            <li className="nav-item">
                                <div className="nav-link m-2 menu-item" onClick={() => this.handleOnOpenVerifyDialog('login')}>登入</div>
                            </li>
                            <li className="nav-item">
                                <div className="nav-link m-2 menu-item" onClick={() => this.handleOnOpenVerifyDialog('register')}>註冊</div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <VerifyDialog
                    open={isOpenVerifyDialog}
                    onClose={this.handleOnOpenVerifyDialog}
                    onSubmit={this.handleOnSubmit}
                    onActionChange={this.handleActionChange}
                    action={this.state.action}
                />
                <ForgetPasswordDialog
                    open={isOpenForgotPasswordDialog}
                    onClose={this.handleCloseForgotPasswordDialog}
                    onActionChange={this.handleActionChange}
                    onSubmit={this.handleForgetPasswordSubmit}
                />
            </header>
        )
    }
}

const mapStateToProps = null

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
    login,
    register,
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header)
